import React from 'react';
import Icon from 'components/lib/icons/icon';

export default function ArrowRightLineIcon(props) {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        d="M5 12h14M13 5l7 7-7 7"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </Icon>
  );
}
